import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export async function deleteMyAccount({ confirmation } = {}) {
  const result = await httpsCallable(functions, "deleteMyAccount")({
    confirmation: String(confirmation || "").trim(),
  });
  return result?.data || { ok: false };
}
